<template>
  <div class="container margin-2xl-top">
    <card :auto-translate="false" title="playground" badge-text="testing area">
      <hr />
      Locale: {{ locale }}<br />

      <form-button
        :theme="locale == 'he-IL' ? 'success' : 'gray'"
        @click="setLocale('he-IL')"
        >HE-IL</form-button
      >
      <form-button
        :theme="locale == 'en-US' ? 'success' : 'gray'"
        @click="setLocale('en-US')"
        >en-US</form-button
      >

      <block class="min-height">
        <div class="flex">
          <form-input v-model="files" type="file" name="file"></form-input>
          <form-button
            :auto-translate="false"
            :loading="asyncStatus.loading"
            @click="uploadFile()"
            >Upload file
          </form-button>
        </div>

        <form-button
          :auto-translate="false"
          class="margin-xl-top"
          :loading="asyncStatus.loading"
          @click="playground()"
          >TEST!
        </form-button>
        <form-button
          :auto-translate="false"
          class="margin-xl-top"
          :loading="asyncStatus.loading"
          @click="playgroundServer()"
          >TEST server!
        </form-button>
        <form-button
          :auto-translate="false"
          class="margin-xl-top"
          :loading="asyncStatus.loading"
          @click="playgroundCustom()"
          >CUSTOM server!
        </form-button>
        <form-button
          :auto-translate="false"
          class="margin-xl-top"
          @click="$store.commit('user/logout')"
          >LOGOUT
        </form-button>
      </block>

      <template #footer> Footer</template>
    </card>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import useMediaManager from "@/client/extensions/composition/useMediaManager";
import ChatView from "@/client/views/Chat.vue";

export default {
  name: "PlaygroundPage",
  components: {
    ChatView,
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let mediaManager = useMediaManager(props, {});
    return { asyncOps, asyncOpsReady, asyncStatus, mediaManager };
  },
  data: function () {
    return {
      test: null,
      country: "DE",
      editorValue: {
        time: 1672578450837,
        blocks: [
          {
            id: "QidNHXH_QP",
            type: "paragraph",
            data: {
              text: "dummy data 1",
            },
          },
          {
            id: "LG7wJF030M",
            type: "paragraph",
            data: {
              text: "dummy data 2<br>",
            },
          },
          {
            id: "KnrHFZEYC4",
            type: "paragraph",
            data: {
              text: "why b4?<br>",
            },
          },
        ],
        version: "2.26.4",
      },
      select2Value: [1, 2],
      select2Value2: null,
      select2FieldList: [
        { value: 0, label: "Chocolate" },
        { value: 1, label: "Strawberry" },
        { value: 2, label: "Taffy" },
        { value: 3, label: "Vanilla" },
        { value: 4, label: "Cookies & cream" },
        { value: 5, label: "Chocolate 2" },
        { value: 6, label: "Strawberry 2" },
        { value: 7, label: "Taffy 2" },
        { value: 8, label: "Vanilla 2" },
        { value: 9, label: "Cookies & cream 2" },
      ],
      files: null,
      pgFormData: {
        name: "original name",
        title: "bogle title",
        nested: {
          name: "original nested name",
        },
      },
      pgForm2Data: {
        accountUUID: "0829a46e-ac41-41e0-ac64-2ac38f58ec66",
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1dWlkIjoiMDgyOWE0NmUtYWM0MS00MWUwLWFjNjQtMmFjMzhmNThlYzY2IiwiZmlsZXMiOlsiMS5qcGciXSwiYWN0aW9ucyI6WyJyZWFkIiwidXBkYXRlIiwiZGVsZXRlIiwiY3JlYXRlIl0sImlhdCI6MTY3MDQxMTk3OCwiZXhwIjoxNjcwNDE1NTc4LCJhdWQiOiJzYWZmcm9uLWZpbGVzIn0.lOYJ7nU2eUNagdzgI9QFdfAnHscfkWHCS6LQjT2xIfw",
        file: "33fc4e09-7e94-4eaa-9325-5ba2b99f8f2e.jpeg",
      },
      playgroundFormConfig: {
        fields: {
          name: {
            name: "name",
            label: "root name",
            validation: {
              required: {},
            },
            group: "group1",
          },
          title: {
            name: "title",
            label: "root title",
            validation: {
              required: {},
            },
            group: "group2",
          },
          nestedName: {
            name: "name",
            label: "name",
            modelTarget: "nested.name",
            validation: {
              required: {},
              minLength: {
                params: {
                  min: 2,
                },
              },
            },
            group: "group2",
          },
        },
        groups: {
          group1: {
            component: "CollapsableFieldSet",
            props: {
              title: "core.genericTitle",
              icon: "file",
            },
          },
          group2: {
            component: "CollapsableFieldSet",
            props: {
              icon: "user",
              title: "core.genericTitle",
            },
          },
        },
      },
      playgroundForm2Config: {
        fields: {
          name: {
            type: "text",
            name: "name",
            label: "core.form.name",
          },
          accountUUID: {
            type: "text",
            name: "accountUUID",
            label: "account uuid",
          },
          token: {
            type: "text",
            name: "token",
            label: "token",
          },
          file: {
            type: "text",
            name: "file",
            label: "file name",
          },
        },
        formHandling: {},
      },
      cake: false,
      asyncData: {
        cake: {
          target: "playground/use-case2",
          data: {
            cakeId: 2,
          },
        },
      },
    };
  },
  computed: {
    pgForm2ComputedAction() {
      let result = "files";
      if (this.pgForm2Data.accountUUID) {
        result = result + "/" + this.pgForm2Data.accountUUID;
      }

      if (this.pgForm2Data.file) {
        result = result + "/" + this.pgForm2Data.file;
      }
      return result;
    },
  },
  watch: {},
  mounted() {
    //  throw new Error('pg error');
  },
  beforeUnmount() {},
  created() {
    //    throw new Error('pg created error');
    //   this.ss('test.testA', 'genericValue!')
    //  console.log('after setter', this.sg('test.testA', 'DEFAULT VALUE'));
  },
  methods: {
    async playground() {},
    async playgroundServer() {
      let payload = {};

      let result = await this.asyncOps.asyncCall("playground/use-case2", payload);

      console.log(result);

      if (result.isError) {
        console.log("request error", result.code, result.status.error);
      } else {
        console.log("request successful");
      }

      console.log("data", result.data);
    },
    async playgroundCustom() {
      let payload = {};
      console.log("run");

      let result = await this.asyncOps.asyncCall("use-case/list/acl", payload);

      //    let result = await this.asyncOps.asyncCall('acl/by-group', payload);

      console.log(result);

      if (result.isError) {
        console.log("request error", result.code, result.status.error);
      } else {
        console.log("request successful");
      }

      console.log("data", result.data);
    },
    pgFormSuccessHandler(result) {
      console.log("form result is success:", !!result.isError);
      console.log(result.resultData);
    },
    pgForm2SuccessHandler(result) {
      console.log("form 2 result:", !!result.isError);
      console.log(result.resultData);
    },
    async uploadFile() {
      let result;
      await this.performWithUi(async () => {
        return (result = await this.mediaManager.upload(this.files[0]));
      });
      /*
      await this.performWithUi(async () => {
        return (result = await this.mediaManager.rename(
          result.id,
          "test111.png"
        ));
      });

      const test = await this.performWithUi(async () => {
        return (result = await this.mediaManager.delete(result.id));
      });
*/
    },
  },
};
</script>

<style scoped lang="scss"></style>
